/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagefiltercheckinall5Inputs */

const en_ticketpagefiltercheckinall5 = /** @type {(inputs: Ticketpagefiltercheckinall5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All guests`)
};

const de_ticketpagefiltercheckinall5 = /** @type {(inputs: Ticketpagefiltercheckinall5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Gäste`)
};

/**
* | output |
* | --- |
* | "All guests" |
*
* @param {Ticketpagefiltercheckinall5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagefiltercheckinall5 = /** @type {((inputs?: Ticketpagefiltercheckinall5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagefiltercheckinall5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagefiltercheckinall5(inputs)
	return de_ticketpagefiltercheckinall5(inputs)
});
export { ticketpagefiltercheckinall5 as "ticketPageFilterCheckInAll" }